import { useEffect, useState, useRef } from 'react';

const useTime = running => {
  const [now, setNow] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (running) {
      if (!intervalRef.current) {
        intervalRef.current = setInterval(() => setNow(Date.now()), 11);
      }
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [running]);

  return now;
}

export default useTime;
